import { TActions } from '../../../AppModulesWrapper';

import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import { RESET_STATE } from '../../actions/resetState';
import { ICalltrackingState } from '../../types/reducers/calltracking';
import { defaultState } from './defaultState';

export function calltracking(state: ICalltrackingState = defaultState, action: TActions): ICalltrackingState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      const { calltracking } = action.payload;

      return {
        ...state,
        ...calltracking,
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
